module.exports = __webpack_public_path__ + "static/media/use11_ch01.4a5badb2.png";